import { Button } from '../ui/button';
import { Play, X, FileVideo } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const isUploadedVideo = (url) => url && (url.startsWith('/api/uploads/videos/') || url.includes('.amazonaws.com/'));
const isYouTubeUrl = (url) => url && (url.includes('youtube.com') || url.includes('youtu.be'));

export const VideoPreview = ({ videoUrl, onRemove }) => (
  <div className="bg-black border border-border p-4 rounded" data-testid="video-preview-container">
    <div className="flex items-center justify-between mb-3">
      <span className="text-sm text-muted-foreground">Current Video:</span>
      <Button
        type="button" variant="ghost" size="sm" onClick={onRemove}
        className="text-red-400 hover:text-red-300 hover:bg-red-500/10 h-8"
        data-testid="remove-video-btn"
      >
        <X className="h-4 w-4 mr-1" /> Remove
      </Button>
    </div>

    {isUploadedVideo(videoUrl) ? (
      <div className="space-y-2">
        <div className="flex items-center gap-2 text-green-400">
          <FileVideo className="h-4 w-4" />
          <span className="text-sm">Uploaded video</span>
        </div>
        <video
          src={videoUrl.startsWith('http') ? videoUrl : `${API}${videoUrl}`}
          controls playsInline preload="metadata"
          className="w-full max-h-48 bg-black rounded"
          data-testid="video-preview"
        />
      </div>
    ) : isYouTubeUrl(videoUrl) ? (
      <div className="space-y-2">
        <div className="flex items-center gap-2 text-red-400">
          <Play className="h-4 w-4" />
          <span className="text-sm">YouTube video</span>
        </div>
        <a href={videoUrl} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline text-sm flex items-center gap-1">
          <Play className="h-4 w-4" /> Open in YouTube
        </a>
      </div>
    ) : (
      <a href={videoUrl} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline text-sm flex items-center gap-1">
        <Play className="h-4 w-4" /> Preview Video
      </a>
    )}
  </div>
);
